import React from 'react';
import AutoCompleteTask from '../reusable-components/autoComplete/autoCompleteTask';
import SpeedDials from './SpeedDial';
import Resource from './resource/Resource';
import '../../assets/scss/autocomplete.scss';
import drag_icon from '../../assets/images/drag_icon.svg';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertOutlinedIcon from '@material-ui/icons/MoreVertOutlined';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import AlertDialog from './AlertDialog/AlertDialog';
import NumberFormat from 'react-number-format';
import $ from 'jquery';
import uuid from 'react-uuid';
import fire from '../../config/firebase';
import FormatMoneyStr from '../../libs/formatMoneyStr';
import { getCopyName } from '../../libs/getCopyName';
export default class Task extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            speed: false,
            showResources: false,
            type: '',
            expandTask1: false,
            countTask: 0,
            taskList: [],
            dialogOpen: false,
            autoCompleteChange: 0
        }
        this.wrapperRef = React.createRef();
        this.wrapperRef1 = React.createRef();
        this.el = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.deleteResource = this.deleteResource.bind(this);
        this.resourceItem = this.resourceItem.bind(this);
        this.updateResource = this.updateResource.bind(this);
        this.addResource = this.addResource.bind(this);
        this.duplicateResource = this.duplicateResource.bind(this);

        this.addEmptyResource = this.addEmptyResource.bind(this);

        this.updateTask = this.updateTask.bind(this);
        this.deleteHandler = this.deleteHandler.bind(this);

        this.openDrop1 = this.openDrop1.bind(this);

        this.closeHandler = this.closeHandler.bind(this);
        this.expandResources = this.expandResources.bind(this);
        this.qtyIncrease = this.qtyIncrease.bind(this);
        this.qtyDecrease = this.qtyDecrease.bind(this);
        this.refreshData = this.refreshData.bind(this);
        this.addNewTask = this.addNewTask.bind(this);
    }
    deleteHandler() {
        this.props.deleteTask(this.props.task);
        this.setState({
            dialogOpen: false,
        });
    }
    duplicateResource(resource) {
        const { task } = this.props;
        const newResource = { ...resource, resourceId: uuid() }
        newResource.resourceName = getCopyName(newResource.resourceName, task.resources, 'resourceName');
        task.resources.push(newResource);
        this.props.updateTask(this.props.task, { resources: task.resources });
    }
    addResource(resourceData, oldResource) {
        resourceData.type = oldResource.type;
        const { task } = this.props;
        const onSuccess = (resourceDrawerData) => {

            delete resourceDrawerData.resoureName;
            const listRef = fire.database().ref('resources');
            const keys = Object.keys(resourceDrawerData);
            for (const key of keys) {
                if (resourceDrawerData[key] === undefined) {
                    delete resourceDrawerData[key];
                }
            }
            listRef.push(resourceDrawerData);
            const newResource = Object.assign({}, oldResource, resourceData, resourceDrawerData);
            newResource.type = newResource.subtitle;
            delete newResource.subtitle;
            delete resourceDrawerData.title;
            const resourceIndex = task.resources.findIndex(d => d.resourceId === oldResource.resourceId);
            task.resources[resourceIndex] = newResource;
            this.props.updateTask(this.props.task, { resources: task.resources });
        };
        const onCancel = () => {
            this.setState({ autoCompleteChange: this.state.autoCompleteChange + 1 });
        }
        this.toggleDrawer(resourceData, onSuccess, onCancel);

    }
    updateResource(resourceData, oldData) {
        const { task } = this.props;
        const safeIconJson = (d) => {
            if (d && d.icon && typeof d.icon === 'object') {
                return JSON.stringify(d.icon, null, 2);
            }
            return null;
        }
        const index = task.resources.findIndex(d => d.resourceId === oldData.resourceId);
        const dbResource = task.resources[index];
        if (dbResource) {
            delete resourceData.resourceId;
            const result = Object.assign({}, dbResource, resourceData);
            result.icon = safeIconJson(result);
            task.resources[index] = result;
            this.props.updateTask(this.props.task, { resources: task.resources });
        }
        console.log('update resource');
    }
    componentWillReceiveProps(newProps) {
        if (
            newProps.swapped ||
            newProps.touched
        ) {
            this.setState({
                offsetY: this.el.getBoundingClientRect().top
            })
        }
    }
    componentDidUpdate() {
        const { offsetY } = this.state
        if (offsetY) {
            const { top } = this.el.getBoundingClientRect()
            this.transform(offsetY - top)
            setTimeout(
                () => {
                    this.resetTransform()
                    this.setState({ offsetY: 0 })
                },
                10
            );
        }
    }
    updateTask(data) {
        this.props.updateTask(this.props.task, data);
        this.refreshData();
    }
    addNewTask(data) {
        const taskRef = fire.database().ref('tasks');
        if (this.state.taskList.find(d => d.title !== data.title)) {
            taskRef.push(data);
        }
    }
    refreshData() {
        const listRef = fire.database().ref('tasks');
        const set = new Set();
        listRef.once('value').then((snapshot) => {
            const list = snapshot.val();
            listRef.off('value');
            const listArr = [];
            for (const id in list) {
                if (set.has(list[id].title) === false) {
                    listArr.push({ id, ...list[id] });
                    set.add(list[id].title);
                }
            }
            this.setState({ taskList: listArr, loader: false });
        });
        if (this.props.task.resources.length > 0) {
            this.setState({ showResources: true })
        }
    }
    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
        this.refreshData()
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }
    handleClickOutside(event) {
        if (this.wrapperRef1.current === null) {
            return false;
        }
        else if (this.wrapperRef1 && !this.wrapperRef1.current.contains(event.target)) {
            this.setState({
                expandTask1: false
            })
        }
    }

    toggleDrawer(data, onSucces, onCancel) {
        this.props.drawerInfoUpdate(data, onSucces, onCancel);
        this.props.toggleDrawer();
    }

    addEmptyResource(role) {
        const { task } = this.props;
        const resource = {
            qty: 1,
            hours: 1,
            resourceId: uuid(),
            cost: 0,
            amount: 0,
            type: role
        };
        if (!task.resources) {
            task.resources = [];
        }
        task.resources.push(resource);
        this.props.updateTask(this.props.task, { resources: task.resources });
    }

    resourceItem() {
        this.setState({
            showResources: true,
        });
    }
    deleteResource(resource) {
        const resources = this.props.task.resources.filter((d) => d.resourceId !== resource.resourceId);
        this.props.updateTask(this.props.task, { resources });
    }
    closeHandler() {
        this.setState({ dialogOpen: false });
    }
    openDrop1(e) {
        const target = this.state.expandTask1;
        this.setState({ expandTask1: !target });
        this.setState({ expandTask: false });
        const row = e.currentTarget.closest(".task-outer");
        const cnt = $(row).find(".task-count").length;
        this.setState({ countTask: cnt });
    }
    expandResources(e) {
        e.currentTarget.closest(".row").classList.toggle('expandResources');
        const row = e.currentTarget.closest(".row");
        $(row).find(".resource").slideToggle();
    }
    qtyIncrease() {
        this.props.updateTask(this.props.task, { qty: this.props.task.qty + 1 });
    }
    qtyDecrease() {
        if (this.props.task.qty === 1) { return false; }
        this.props.updateTask(this.props.task, { qty: this.props.task.qty - 1 });
    }

    render() {
        const { task, totalTaskPrice, estimate = {} } = this.props;
        const { taskList = [], autoCompleteChange } = this.state;
        const { taskName } = task;
        return (
            <React.Fragment>
                <AlertDialog
                    open={this.state.dialogOpen}
                    onClose={this.closeHandler}
                    keyValue={this.deleteHandler}
                    name={"task"}
                />
                <div className="row" key={`dfirst`} >
                    <div className="input-field col s12 l4 m4 " key="dfirst1">
                        <span>Task</span>
                        <AutoCompleteTask
                            type="task"
                            update={this.updateTask}
                            selectValue={taskName}
                            onChange={this.updateTask}
                            dataList={taskList}
                            classes={this.props.classes.addTask}
                            title={'Task Name'}
                            cla="taskName"
                            insert={this.addNewTask}
                        />
                    </div>
                    <div className="col s12 l8 m8 counting-phase" key="dfirst2">
                        <div className="counting-phase-qty">
                            <span>QTY</span>
                            <div className="list task_qty qty gray-circle" key="dfirst4">
                                <input type="number" min="0"
                                    value={task.qty} readOnly={true} />
                                {task.qty < 2 ?
                                    <DeleteOutlinedIcon
                                        htmlColor="#000000"
                                        fontSize="small"
                                        className="delete"
                                        onClick={() => {
                                            this.setState({ dialogOpen: true });
                                        }}
                                    />
                                    :
                                    <RemoveIcon
                                        htmlColor="#000000"
                                        fontSize="small"
                                        className="delete"
                                        onClick={() => {
                                            this.qtyDecrease()
                                        }}
                                    />
                                }
                                <AddIcon
                                    htmlColor="#000000"
                                    fontSize="small"
                                    className="add"
                                    onClick={() => {
                                        this.qtyIncrease()
                                    }
                                    } />
                            </div>
                        </div>
                        <div className="counting-phase-total" style={{ marginLeft: '5px' }} key="dfirst3">
                            <span>Subtotal</span>
                            <NumberFormat id={`task_total-${4}`}
                                className="subtotal"
                                allowNegative={false}
                                isNumericString={true}
                                thousandSeparator={true}
                                placeholder="0"
                                style={{ textAlign: 'right', right: '6px', top: '-4px', border: '0', fontWeight: '600', color: 'rgba(0,0,0,0.5)', position: 'relative' }}
                                value={FormatMoneyStr({ number: totalTaskPrice })}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="col s12 resource" style={{ 'marginTop': '0' }} key="d1">
                        <div className="one-line-elment one-line-title" key="d11">
                            <div className="list">
                                <h5>Resources</h5>
                            </div>
                            {this.state.showResources && (<React.Fragment>
                                <div className='title-resource-wrap' key="d6">
                                    <div className="list drop-box qty title" key="d2">
                                        QTY
                                    </div>
                                    <div className="list hrs title" key="d3">
                                        Hours
                                    </div>
                                    <div className="list cost title" key="d4">
                                        Cost
                                    </div>
                                    <div className="list subtotal title" key="d5">
                                        Subtotal
                                    </div>
                                </div>
                            </React.Fragment>)
                            }

                        </div>

                        {
                            task?.resources?.map((resource, index) => <Resource
                                resource={resource}
                                updateCnt={this.props.updateCnt}
                                estimate={estimate}
                                addResource={this.addResource}
                                duplicateResource={this.duplicateResource}
                                editResources={this.editResources}
                                deleteResource={this.deleteResource}
                                updateResource={(newData, oldData) => this.updateResource(newData, oldData ? oldData : newData)}
                                classes={this.props.classes}
                                key={`${index}-${(resource.resourceName || '')}${(autoCompleteChange || '')}`}
                                toggleEditDrawer={this.props.toggleEditDrawer}
                                editVendorValue={this.props.editVendorValue}
                            />)
                        }
                        <SpeedDials
                            click={this.addEmptyResource}
                            buttonItem={this.props.buttonItem}
                            defineRoleType={this.defineRoleType}
                            showResources={this.resourceItem}
                        />
                    </div>
                    <span className="icon-box" key="dfirst6">
                        <img src={drag_icon} alt="Drag" />
                    </span>
                    <div className={this.state.expandTask1 ? 'active content-outer' : 'content-outer'} key="dfirst7">
                        <span className="top-arrow" onClick={this.expandResources}>
                            <ExpandMoreIcon htmlColor='#000' />
                        </span>
                        <MoreVertOutlinedIcon htmlColor='#000' className='open-close' onClick={this.openDrop1} ref={this.wrapperRef1} />
                        {this.state.expandTask1 && (<ul>
                            <li className="taskDuplicate" onClick={() => this.props.duplicateTask(this.props.task)}><span className="img-box">
                                <FileCopyOutlinedIcon htmlColor='#000' /></span> Duplicate</li>
                            {this.state.countTask > 1 || true ?
                                <li className="taskDelete" onClick={() => this.setState({ dialogOpen: true })}>
                                    <span className="img-box"><DeleteOutlineOutlinedIcon htmlColor='#000' /></span> Delete</li>
                                : ""}

                        </ul>)}
                    </div>
                </div>
            </React.Fragment>

        )
    }

}